// FAZ 4 — SÜRÜKLEME BAŞLANGICI HIZLI MOD (tek anahtar).
//
// Ölçülen kök neden (90 kart / 100+ alt görev, 1600x950): sürükleme başlarken
// dnd-kit'in Cursor (`* { cursor: grabbing }`) ve PreventSelection
// (`* { user-select: none }`) eklentileri <head>'e EVRENSEL seçicili stil
// ekliyor; her ekleme/kaldırma ~8.300 elemanın stilini baştan hesaplatıyor
// (~77 ms/adet, tek karede 2-3 kez). Ayrıca tüm liste yeniden çiziliyor ve
// 190+ "İÇİNE" noktası o anda DOM'a ekleniyordu.
//
// Hızlı modda: evrensel stil eklenmez (seçim engeli olay dinleyicisiyle
// yapılır), noktalar hep kayıtlı kalır ve yalnızca kendileri görünür olur.
// `false` yapılırsa davranış eskisiyle BİREBİR aynıdır.
import { Plugin } from "@dnd-kit/abstract";
import { Cursor, PreventSelection, StyleInjector } from "@dnd-kit/dom";

export const SURUKLE_HIZLI_MOD_ACIK = true;

// Feedback eklentisinin stilindeki `@layer dnd-kit {…}` bloğu, her sürükleme
// başında/sonunda eklenip kaldırıldığı için TÜM sayfanın stilini yeniden
// hesaplatıyor (~40-65 ms). Blok yalnızca sürüklenen öğeye (`[data-dnd-dragging]`)
// uyduğundan, AYNI metin bir kez kalıcı yazılır; kalan kurallar dnd-kit'in
// kendisi tarafından eskisi gibi eklenip kaldırılır.
const KATMAN_BAS = "@layer dnd-kit {";
const katmaniAyir = (css) => {
  const i = css.indexOf(KATMAN_BAS);
  if (i < 0) return null;
  let derinlik = 0;
  for (let j = i + KATMAN_BAS.length - 1; j < css.length; j += 1) {
    if (css[j] === "{") derinlik += 1;
    else if (css[j] === "}") {
      derinlik -= 1;
      if (derinlik === 0) return { katman: css.slice(i, j + 1), kalan: css.slice(0, i) + css.slice(j + 1) };
    }
  }
  return null;
};
const kaliciKatmanlar = new Set();
const katmaniKaliciYaz = (katman) => {
  if (kaliciKatmanlar.has(katman)) return;
  kaliciKatmanlar.add(katman);
  const s = document.createElement("style");
  s.setAttribute("data-sx-dnd-katman", "");
  s.textContent = katman;
  document.head.prepend(s);
};

export class KaliciKatmanStili extends Plugin {
  constructor(manager, options) {
    super(manager, options);
    const si = manager.registry.plugins.get(StyleInjector);
    if (!si || si.sxKatmanSarili) return;
    si.sxKatmanSarili = true;
    const asil = si.register.bind(si);
    si.register = (css) => {
      const ayrik = typeof css === "string" ? katmaniAyir(css) : null;
      if (!ayrik) return asil(css);
      katmaniKaliciYaz(ayrik.katman);
      return asil(ayrik.kalan);
    };
  }
}

const secimiKaldir = () => document.getSelection()?.removeAllRanges();
const secimiEngelle = (e) => e.preventDefault();

// PreventSelection'ın CSS'siz karşılığı: sürükleme sırasında metin seçimi
// başlatılamaz ve oluşan seçim temizlenir.
export class SecimEngeli extends Plugin {
  constructor(manager, options) {
    super(manager, options);
    this.registerEffect(() => {
      if (!this.manager.dragOperation.status.initialized) return undefined;
      secimiKaldir();
      document.addEventListener("selectionchange", secimiKaldir, { capture: true });
      document.addEventListener("selectstart", secimiEngelle, { capture: true });
      return () => {
        document.removeEventListener("selectionchange", secimiKaldir, { capture: true });
        document.removeEventListener("selectstart", secimiEngelle, { capture: true });
      };
    });
  }
}

export const hizliEklentiler = (liste) =>
  SURUKLE_HIZLI_MOD_ACIK
    ? [KaliciKatmanStili, ...liste.filter((p) => p !== Cursor && p !== PreventSelection), SecimEngeli]
    : liste;
